const routes = [
  {
    path: '/reports',
    // Old Reports links name a report as ?report=<code>; an embedded app receives only app_ params.
    redirect: ({ query: { report, ...query } }) => ({
      path: '/embedded/vsight/reports',
      query: report ? { ...query, app_report: report } : query,
    }),
  },
];

export default routes;
